import React from "react";
import Dashboard from "./Dashboard";

/** Default app route (/) — setup guide; install gate is in App.js */
export default function Home() {
  return <Dashboard />;
}
